// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-9382c8b2] .detail-modal-dialog {
  display: flex;
  align-items: center;
  width: min(96vw, 1440px);
  max-width: min(96vw, 1440px);
  min-height: calc(100% - 2rem);
  margin: 1rem auto;
}
[data-v-9382c8b2] .detail-modal-dialog .modal-content {
  height: 80vh;
}
.detail-layout[data-v-9382c8b2] {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.detail-section[data-v-9382c8b2] {
  padding: 1rem;
  border: 1px solid #e5ebf2;
  border-radius: 8px;
  background: #ffffff;
}
.detail-kv-table[data-v-9382c8b2] {
  width: 100%;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}
.detail-kv-row[data-v-9382c8b2] {
  display: grid;
  grid-template-columns: 35% 65%;
  border-bottom: 1px solid #dee2e6;
}
.detail-kv-row[data-v-9382c8b2]:last-child {
  border-bottom: none;
}
.detail-kv-label[data-v-9382c8b2] {
  background: #f8fafc;
  font-weight: 600;
  vertical-align: top;
  padding: 0.5rem 0.75rem;
  border-right: 1px solid #dee2e6;
}
.detail-kv-value[data-v-9382c8b2] {
  white-space: pre-wrap;
  word-break: break-word;
  padding: 0.5rem 0.75rem;
  background: #ffffff;
}
.detail-pre[data-v-9382c8b2] {
  max-height: 260px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.85rem;
  color: #243443;
}
.detail-empty[data-v-9382c8b2] {
  padding: 0.95rem 1rem;
  border-radius: 8px;
  border: 1px dashed #d6dde6;
  color: #6c757d;
  background: #fcfdff;
}
.history-list[data-v-9382c8b2] {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.history-block[data-v-9382c8b2] {
  padding: 0.85rem;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  background: #fbfcfd;
}
@media only screen and (max-width: 1200px) {
.buscador-results-table table[data-v-9382c8b2],
  .buscador-results-table thead[data-v-9382c8b2],
  .buscador-results-table tbody[data-v-9382c8b2],
  .buscador-results-table th[data-v-9382c8b2],
  .buscador-results-table td[data-v-9382c8b2],
  .buscador-results-table tr[data-v-9382c8b2] {
    display: block;
}
.buscador-results-table thead tr[data-v-9382c8b2] {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.buscador-results-table tr[data-v-9382c8b2] {
    border: 1px solid #ccc;
    margin-bottom: 8px;
}
.buscador-results-table td[data-v-9382c8b2] {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
    white-space: normal;
    text-align: left;
}
.buscador-results-table td[data-v-9382c8b2]:before {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 45%;
    padding-right: 8px;
    white-space: nowrap;
    font-weight: 600;
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(1):before {
    content: 'ID INC';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(2):before {
    content: 'ID OCEANE';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(3):before {
    content: 'Tipo';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(4):before {
    content: 'Fecha ticket';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(5):before {
    content: 'Canal';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(6):before {
    content: 'Fecha mensaje';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(7):before {
    content: 'Errores';
}
.buscador-results-table td[data-v-9382c8b2]:nth-of-type(8):before {
    content: 'Acciones';
}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/BuscadorIncidencias.vue"],"names":[],"mappings":";AAgeA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;AACnB;AAEA;EACE,YAAY;AACd;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AAEA;AAEE;;;;;;IAME,cAAc;AAChB;AAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACf;AAEA;IACE,sBAAsB;IACtB,kBAAkB;AACpB;AAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AAClB;AAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AAClB;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,oBAAoB;AACtB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,uBAAuB;AACzB;AAEA;IACE,gBAAgB;AAClB;AAEA;IACE,wBAAwB;AAC1B;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,mBAAmB;AACrB;AACF","sourcesContent":["\n:deep(.detail-modal-dialog) {\n  display: flex;\n  align-items: center;\n  width: min(96vw, 1440px);\n  max-width: min(96vw, 1440px);\n  min-height: calc(100% - 2rem);\n  margin: 1rem auto;\n}\n\n:deep(.detail-modal-dialog .modal-content) {\n  height: 80vh;\n}\n\n.detail-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.detail-section {\n  padding: 1rem;\n  border: 1px solid #e5ebf2;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.detail-kv-table {\n  width: 100%;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.detail-kv-row {\n  display: grid;\n  grid-template-columns: 35% 65%;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.detail-kv-row:last-child {\n  border-bottom: none;\n}\n\n.detail-kv-label {\n  background: #f8fafc;\n  font-weight: 600;\n  vertical-align: top;\n  padding: 0.5rem 0.75rem;\n  border-right: 1px solid #dee2e6;\n}\n\n.detail-kv-value {\n  white-space: pre-wrap;\n  word-break: break-word;\n  padding: 0.5rem 0.75rem;\n  background: #ffffff;\n}\n\n.detail-pre {\n  max-height: 260px;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 0.85rem;\n  color: #243443;\n}\n\n.detail-empty {\n  padding: 0.95rem 1rem;\n  border-radius: 8px;\n  border: 1px dashed #d6dde6;\n  color: #6c757d;\n  background: #fcfdff;\n}\n\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.history-block {\n  padding: 0.85rem;\n  border: 1px solid #e8edf3;\n  border-radius: 8px;\n  background: #fbfcfd;\n}\n\n@media only screen and (max-width: 1200px) {\n\n  .buscador-results-table table,\n  .buscador-results-table thead,\n  .buscador-results-table tbody,\n  .buscador-results-table th,\n  .buscador-results-table td,\n  .buscador-results-table tr {\n    display: block;\n  }\n\n  .buscador-results-table thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .buscador-results-table tr {\n    border: 1px solid #ccc;\n    margin-bottom: 8px;\n  }\n\n  .buscador-results-table td {\n    border: none;\n    border-bottom: 1px solid #eee;\n    position: relative;\n    padding-left: 50%;\n    white-space: normal;\n    text-align: left;\n  }\n\n  .buscador-results-table td:before {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    width: 45%;\n    padding-right: 8px;\n    white-space: nowrap;\n    font-weight: 600;\n  }\n\n  .buscador-results-table td:nth-of-type(1):before {\n    content: 'ID INC';\n  }\n\n  .buscador-results-table td:nth-of-type(2):before {\n    content: 'ID OCEANE';\n  }\n\n  .buscador-results-table td:nth-of-type(3):before {\n    content: 'Tipo';\n  }\n\n  .buscador-results-table td:nth-of-type(4):before {\n    content: 'Fecha ticket';\n  }\n\n  .buscador-results-table td:nth-of-type(5):before {\n    content: 'Canal';\n  }\n\n  .buscador-results-table td:nth-of-type(6):before {\n    content: 'Fecha mensaje';\n  }\n\n  .buscador-results-table td:nth-of-type(7):before {\n    content: 'Errores';\n  }\n\n  .buscador-results-table td:nth-of-type(8):before {\n    content: 'Acciones';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
